import React from "react";
import { Grid, Button } from "@mui/material";

export default function dowloadBT() {
  return (
    <Grid container alignItems="center" sx={{ margin: "10px" }}>
      <Button
        variant="outlined"
        style={{ color: "#84BD5A", borderColor: "#84BD5A" }}

        // onClick={onClickEdit}
      >
        <span className="material-icons-outlined">description</span>
        Export
      </Button>
    </Grid>
  );
}
